export default __webpack_public_path__ + "static/media/8.32211f99.pdf";